import React, { useState, useEffect } from "react";
import "./styles/Hero.css";

import heroImg1 from "../assets/boutus.jpg";
import heroImg2 from "../assets/banner2.jpg";
import vid1 from "../assets/vid.mp4";
import vid8 from "../assets/r8.mp4";
import vid2 from "../assets/vid2.mp4";
import vid3 from "../assets/vid3.mp4";
import vid4 from "../assets/vid4.mp4";
import vid5 from "../assets/vid5.mp4";
import vid6 from "../assets/vid6.mp4";
import vid7 from "../assets/vid7.mp4";

import logo from "../assets/logo air.png";

const Hero = () => {
  const imageList = [heroImg1, heroImg2];
  const videoList = [vid1, vid2, vid3, vid4, vid5, vid6, vid7,vid8];
  const [showVideo, setShowVideo] = useState(false);
  const [videoIndex, setVideoIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    // Show video after 4 seconds
    const showTimer = setTimeout(() => {
      setShowVideo(true);
    }, 4000);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (!showVideo) return;

    // Start cycling videos every 5 seconds
    const interval = setInterval(() => {
      setVideoIndex((prevIndex) => (prevIndex + 1) % videoList.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [showVideo]);

  return (
    <section className="hero-section">
      {showVideo ? (
        <video
          key={videoIndex} // Ensures video reloads on change
          className="hero-bg"
          src={videoList[videoIndex]}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
       <img src={imageList[imageIndex]} alt="Hero" className="hero-bg" />
         
      )}

      <div className="hero-content">
        <img src={logo} alt="Airflex Logo" className="logo-img-banner" />
        <p>At Airflex RSA, your car is not just a car — it’s a statement.
        </p>
        <a href="#contact"><button >For More Info</button></a>
      </div>
    </section>
  );
};

export default Hero;
